import { connect } from 'react-redux';
import { compose, withProps, withHandlers, branch, renderNothing } from 'recompose';

import ResetServicesOrderButton from '../components/ResetServicesOrderButton';
import confirmModal from '../../../common/confirmModal';
import withPermissions from '../../../auth/utils/withPermissions';
import withNotifications from '../../../common/withNotifications';
import {
  canUserModifyBarbers,
  canUserModifyServices,
  canUserViewServices,
} from '../../../common/helpers/users';
import { resetAllBarbersServiceOrder, resetBarberServicesOrder } from '../actions';
import { activeShop } from '../../../auth/selectors';
import { t } from '../../../../modules/infra/i18n';

export default compose(
  connect(state => ({
    shop: activeShop(state),
  }), {
    resetAllBarbersServiceOrder,
    resetBarberServicesOrder,
  }),
  withPermissions,
  withNotifications,
  withProps(props => ({
    shouldShowResetOrderButton:
      canUserViewServices(props.permissions) && canUserModifyServices(props.permissions)
      && canUserModifyBarbers(props.permissions),

    resetModalTitle: props.barber ? t('barber:services.reset_modal.staff_member_title') : t('barber:services.reset_modal.all_staff_title'),
    resetModalMessage: props.barber ?
      t('barber:services.reset_modal.staff_member_message')
      : t('barber:services.reset_modal.all_staff_message'),
  })),
  withHandlers({
    resetServicesOrder: props => () => {
      if (props.barber) {
        return props.resetBarberServicesOrder(props.shop.id, props.barberId);
      }

      return props.resetAllBarbersServiceOrder(props.shop.id);
    },
  }),
  withHandlers({
    onButtonClick: props => async () => {
      const confirmed = await confirmModal({
        title: props.resetModalTitle,
        message: props.resetModalMessage,
        type: 'yesno',
        confirmButtonText: t('barber:services.reset_modal.confirm_button'),
        negativeButtonText: t('barber:services.reset_modal.cancel_button'),
      });

      if (!confirmed) {
        return false;
      }

      return props.resetServicesOrder()
        .then(() => props.addNotification({
          level: 'success',
          message: t('barber:services.reset_success_message'),
          title: t('barber:services.reset_success_title'),
        }));
    },
  }),
  branch(props => !props.shouldShowResetOrderButton, renderNothing),
)(ResetServicesOrderButton);
